<template>
  <div class="w-full">
    <table>
      <thead>
        <slot name="header"></slot>
      </thead>
      <tbody>
      <tr>
        <td>roserGMEnabled</td>
        <slot name="cookie-1"></slot>
        <td>30 {{ daysLabel }}</td>
        <td>
          <div class="checkbox">
            <input type="checkbox" id="maps" @click="updateMapsPermission" :checked="mapsPermitted">
            <label class="hidden justify-center" for="maps"></label>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import eventBus from '@/util/event-bus'
import { EVENT } from '@/util/enums'
import PermissionsHelper from '@/util/permissions'

export default {
  props: {
    lang: {
      type: String,
      required: false,
      default() {
        return 'de-DE'
      }
    }
  },
  data() {
    return {
      mapsPermitted: false,
    }
  },
  mounted() {
    this.mapsPermitted = !!Number(PermissionsHelper.mapsPermitted)
  },
  computed: {
    daysLabel() {
      return this.lang === 'de-DE' ? 'Tage' : 'days'
    }
  },
  methods: {
    updateMapsPermission() {
      this.mapsPermitted = !this.mapsPermitted
      PermissionsHelper.mapsPermitted = Number(this.mapsPermitted)
      eventBus.$emit(EVENT.PERMISSIONS_CHANGED)
    },
  }
}
</script>
<style>
table {
  border-collapse: collapse;
  max-width: 100%;
  width: 100%;
  empty-cells: show;
  box-sizing: inherit;
  outline: none !important;
}

tbody {
  outline: none !important;
}

thead th {
  font-weight: normal !important;
  text-align: left;
}

table th,
table td {
  border: 1px solid #eee;
  padding: 16px;
  padding-bottom: 15px;
}

table:not(.data) th:not(:last-child),
table:not(.data) td:not(:last-child) {
  padding-right: 12px;
}

@screen mo {
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  table tr {
    @apply mt-12;
  }
  table td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  table td:before {
    position: absolute;
    top: 15px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
  td:nth-of-type(1):before { content: "Name"; }
  td:nth-of-type(2):before { content: "Funktion"; }
  td:nth-of-type(3):before { content: "Läuft ab"; }
  td:nth-of-type(4):before { content: "Gehnemigt"; }
}
</style>
